import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PiLock } from "react-icons/pi";
import { IconoEstado, PaginaCuenta } from "../Registro/AuthComun";

// ══════════════════════════════════════════════════════
//  «No tienes permiso para ver esta página» (sesión válida pero sin rol de admin)
//  No se redirige en silencio: así se entiende qué ha pasado. No se monta nada del
//  panel, así que tampoco se piden datos a la API.
// ══════════════════════════════════════════════════════

const SinPermiso = ({ texto = "Esta zona es solo para el administrador de la web." }) => {
  useEffect(() => {
    const anterior = document.title;
    document.title = "Sin permiso · Plato tras Plato";
    return () => {
      document.title = anterior;
    };
  }, []);

  return (
    <PaginaCuenta>
      <section className="cu-panel cu-panel--centrado" aria-labelledby="sp-titulo">
        <IconoEstado tipo="error" icono={PiLock} />
        <h1 className="cu-titulo" id="sp-titulo">No tienes permiso para ver esta página</h1>
        <p className="cu-intro">
          {texto} Si crees que es un error, escríbenos desde la página de contacto.
        </p>
        <div className="cu-acciones">
          <Link to="/" className="cu-btn">Ir al inicio</Link>
          <Link to="/contacto" className="cu-btn cu-btn--secundario">Contacto</Link>
        </div>
      </section>
    </PaginaCuenta>
  );
};

export default SinPermiso;
